import React from 'react';
import '../template-file-css/document-file-template.css';


export const ACTS_AmethystTreatmentConsent = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='ACTS_AmethystTreatmentConsent' className='file-pdf-document'>
            <div className='file-template w-750'>
                <h3>AMETHYST TREATMENT CONSENT
                </h3>
                <p className='w-750'>
                    After clear explanation of the program structure, rules and expectations, including alleged
                    benefits, potential risks and possible alternative methods of treatment/habilitation. I am
                    requesting evaluation/treatment for mental health, substance abuse and/or other services at
                    Amethyst. If following the evaluation, it is determined that further treatment is appropriate, I
                    hereby, consent to treatment/habilitation as deemed necessary. I further understand that goals
                    of treatment will be discussed with me and I may refuse/withdraw from services at any time. In
                    case of accident or illness, I also give my consent for Amethyst Consulting & Treatment Solutions,
                    PLLC staff to provide and/or obtain emergency medical treatment.
                </p>
                <p className='w-750'>
                    I understand that in order for treatment/habilitation to be successful it will be necessary to
                    attend all treatment sessions at the scheduled time. I agree to notify Amethyst Consulting &
                    Treatment Solutions, PLLC at least 24 hours prior to appointment time in the event I will be
                    unable to attend a scheduled session.
                </p>
                <p className='w-750'>
                    <strong>I also understand that Amethyst Therapists provides neither custody evaluation
                        recommendation nor medication/prescription recommendation nor legal advice, as these
                        activities do not fall within our scope of practice.
                    </strong>
                </p>
                <p className='w-750'>
                    I fully understand the above statements, which have been read and explained to me by a member
                    of Amethyst Consulting & Treatment Solutions, PLLC.
                </p>
                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp;
                        </td>
                        <td className='signature w-250'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Client/Responsible Party Signature: </td>
                        <td className='small w-250'>Date: </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp;
                        </td>
                        <td className='signature w-250'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Amethyst Representative Signature:
                        </td>
                        <td className='small w-250' >Date:
                        </td>
                    </tr>
                </table>
                


            {/* <table>
               <tr>
                  <td className='w-450'> <span className='eleHeader'>1. Name of Medication:</span> </td>
                  <td className='w-150'> <span className='eleHeader'>Date Initiated:</span> </td>
                  <td className='w-150'> <span className='eleHeader'>Date Terminated/ Changed:</span> </td> 
               </tr>
               <tr>
                  <td className='w-450'> <input type='text' id='txtMedication_' name='txtMedication_' className='add-only' /> </td>
                  <td className='w-150'> <input type='date' id='txtDateInitiated_' name='txtDateInitiated_' className='add-only' /> </td> 
                  <td className='w-150'> <input type='date' id='txtDateTerminated_' name='txtDateTerminated_' className='add-only' /> </td> 
               </tr>
               <tr>
                  <td className='w-375'> <span className='eleHeader'>Prescribed By:</span> </td>
                  <td className='w-375'> <span className='eleHeader'>Dosage/Frequency:</span> </td>
               </tr>
               <tr>
                  <td className='w-375'> <input type='text' id='txtPrescribedBy_' name='txtPrescribedBy_' className='add-only' /> </td> 
                  <td className='w-375'> <input type='text' id='txtDosage_' name='txtDosage_' className='add-only' /> </td> 
               </tr>
               <tr> 
                  <td className='signature w-750'>&nbsp;</td>
               </tr>
               <tr> 
                  <td className='small w-750'> Staff Signature/ Credential: </td>
               </tr> 
               
               <tr>
                  <td className='w-450'> <span className='eleHeader'>2. Name of Medication:</span> </td>
                  <td className='w-150'> <span className='eleHeader'>Date Initiated:</span> </td>
                  <td className='w-150'> <span className='eleHeader'>Date Terminated/ Changed:</span> </td> 
               </tr>
               <tr>
                  <td className='w-450'> <input type='text' id='txtMedication_' name='txtMedication_' className='add-only' /> </td>
                  <td className='w-150'> <input type='date' id='txtDateInitiated_' name='txtDateInitiated_' className='add-only' /> </td> 
                  <td className='w-150'> <input type='date' id='txtDateTerminated_' name='txtDateTerminated_' className='add-only' /> </td> 
               </tr>
               <tr>
                  <td className='w-375'> <span className='eleHeader'>Prescribed By:</span> </td>
                  <td className='w-375'> <span className='eleHeader'>Dosage/Frequency:</span> </td>
               </tr>
               <tr>
                  <td className='w-375'> <input type='text' id='txtPrescribedBy_' name='txtPrescribedBy_' className='add-only' /> </td> 
                  <td className='w-375'> <input type='text' id='txtDosage_' name='txtDosage_' className='add-only' /> </td> 
               </tr>
               <tr> 
                  <td className='signature w-750'>&nbsp;</td>
               </tr>
               <tr> 
                  <td className='small w-750'> Staff Signature/ Credential: </td>
               </tr> 

            </table> */}





            </div>
        </form>

    )
}  
